module.exports = __webpack_public_path__ + "static/media/DSC07472-min.96ce3c19.jpg";